import React from 'react'

const CouponConfig = ({ selloutSettings, couponCode }) => {
  if (
    couponCode &&
    selloutSettings &&
    selloutSettings.minicart &&
    selloutSettings.minicart.coupon_rows &&
    selloutSettings.minicart.coupon_rows.length
  ) {
    const filteredRows = selloutSettings.minicart.coupon_rows.filter(row =>
      couponCode.startsWith(row.prefix)
    )

    return (
      filteredRows.length > 0 && (
        <div style={{ width: '100%' }}>
          {filteredRows.map(row => (
            <p
              dangerouslySetInnerHTML={{ __html: row.label_subTitle }}
              key={filteredRows.indexOf(row).toString()}
              style={row.style}
            ></p>
          ))}
        </div>
      )
    )
  }
  return null
}

export default CouponConfig
